export function generatePlaceholderName(seed = null) {
  const adjectives = [
    "Silent", "Hidden", "Quiet", "Grey", "Faint", "Calm", "Unknown", "Dim", "Shy", "Still",
    "Obscure", "Shadowy", "Veiled", "Hushed", "Elusive", "Remote", "Pale", "Wandering",
    "Soft", "Fading", "Secret", "Low", "Murmuring", "Clouded", "Fleeting", "Hollow", "Covered",
    "Invisible", "Sombre"
  ];
 const nouns = [
    "Shadow", "Echo", "Signal", "Spark", "Flare", "Pulse", "Drift", "Trace", "Whisper", "Line",
    "Glimmer", "Ripple", "Thread", "Flicker", "Wave", "Dust", "Blur", "Fragment", "Note", "Shade"
  ];

  // Generate a pseudo-random seed if none is given
  const base = seed ?? Math.random().toString(36).substring(2, 10); // 8 random chars
  const hash = [...base].reduce((acc, char) => acc + char.charCodeAt(0), 0);

  const adj = adjectives[hash % adjectives.length];
  const noun = nouns[(hash >> 2) % nouns.length];
  return `${adj} ${noun}`;
}